import { SECOND_TO_MS } from '@/utils/constants'
import React, { useEffect, useState } from 'react'
import { DFPSlotsProvider } from 'react-dfp'

let GPTConnectionAttemps = 0

const GPTContainer = ({
  children,
  fallback,
  freezingTime,
}: {
  children: React.ReactNode
  fallback: React.ReactElement | null
  freezingTime?: number
}) => {
  const [freeze, setFreeze] = useState(true)

  useEffect(() => {
    const timer = freezingTime || 10
    const refFreeze = setTimeout(() => {
      setFreeze(false)
    }, timer * SECOND_TO_MS)

    const refreshTimeout = setTimeout(() => {
      if (!window?.googletag?.pubads && GPTConnectionAttemps < 3) {
        GPTConnectionAttemps += 1
        // Retry logic would need to be handled differently to avoid infinite recursion
        console.log('GPT not loaded, attempt:', GPTConnectionAttemps)
      } else if (window?.googletag?.pubads) {
        // eslint-disable-next-line no-unused-expressions
        window?.googletag.pubads()?.refresh?.()
      }
    }, (timer + 3) * SECOND_TO_MS)

    return () => {
      clearTimeout(refFreeze)
      clearTimeout(refreshTimeout)
    }
  }, [freezingTime])

  return freeze ? (
    fallback
  ) : (
    <DFPSlotsProvider
      dfpNetworkId=""
      disableInitialLoad
      singleRequest={false}
      lazyLoad={{
        fetchMarginPercent: 500,
        renderMarginPercent: 200,
        mobileScaling: 2.0,
      }}
    >
      {children}
    </DFPSlotsProvider>
  )
}

export default GPTContainer
